import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const STATIC_LIST_PATH = 'staticList'
const USER_STATIC_LIST_PATH = 'userStaticList'

//#region Static List
export function getListStaticList(userId, dto, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${STATIC_LIST_PATH}/getList`,
            filterRequest,
            {
                params: {userId, dto},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPageStaticList(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${STATIC_LIST_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function deleteStaticList(userId, id) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${STATIC_LIST_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region User Static List
export function getStaticListByHospitals(userId, hospitalIds = []) {
    if (!hospitalIds || hospitalIds?.length === 0) {
        return []
    }

    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_STATIC_LIST_PATH}/getMyStaticListByHospitals`,
            hospitalIds,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
